import React from "react";
import { Box, Typography, Link } from "@mui/material";

const formatPerson = (person) => {
  if (typeof person === "string") return person;
  if (!person) return "";
  const name = `${person.name || ""} ${person.lastName || ""}`.trim();
  return person.email ? `${name} <${person.email}>` : name;
};

function PeopleList({ label, people }) {
  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="subtitle2">{label}</Typography>
      {people && people.length ? (
        people.map((person, index) => (
          <Typography key={index} variant="body2" color="text.secondary">
            {formatPerson(person)}
          </Typography>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          —
        </Typography>
      )}
    </Box>
  );
}

export default function FiledSummaryDetails({ item }) {
  const annexes = item?.annexes || [];
  return (
    <>
      <PeopleList label="Destinatario" people={item?.recipients} />
      <PeopleList label="Remitente" people={item?.senders} />
      <Box sx={{ mt: 1 }}>
        <Typography variant="subtitle2">{`Anexos (${annexes.length})`}</Typography>
        {annexes.length ? (
          annexes.map((annex, index) => (
            <Typography key={annex.id || index} variant="body2" color="text.secondary">
              {annex.url ? (
                <Link href={annex.url} target="_blank" rel="noopener">
                  {annex.name}
                </Link>
              ) : (
                annex.name
              )}
            </Typography>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            Sin anexos
          </Typography>
        )}
      </Box>
    </>
  );
}
